import { render, staticRenderFns } from "./bookRepository.vue?vue&type=template&id=3f6a53cc&scoped=true&"
import script from "./bookRepository.vue?vue&type=script&lang=js&"
export * from "./bookRepository.vue?vue&type=script&lang=js&"
import style0 from "./bookRepository.vue?vue&type=style&index=0&id=3f6a53cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a53cc",
  null
  
)

export default component.exports